"use client";
import { usePathname } from 'next/navigation';
import Link from "next/link";
import styles from './AuthenticatedHeaderMenu.module.scss';

interface AuthenticatedHeaderMenuProps {
    isAuthenticated: boolean;
    login: () => void;
    logout: () => void;
    isApiKeyManager: boolean;
};

const AuthenticatedHeaderMenu = ({isAuthenticated, login, logout, isApiKeyManager}: AuthenticatedHeaderMenuProps) => {    
    const pathname = usePathname();
    const isActiveLink = (href: string) => pathname === (href);

    return (
        <div className="ermuivewou ermuivewou-md ermuivewou-xl">
            <nav className="menu menu-wlu0u inline-block">
                <div className="menu menu-horizontal">
                    <ul className="nav">
                        {isAuthenticated ? (
                            <>
                                {isApiKeyManager ? (
                                    <li className={`nav-item ${styles.navItem}`}>
                                        <span className="nav-link">Dashboard</span>
                                        <div className={`dropdown ${styles.dropdown}`}>
                                            <ul className="nav">
                                                <li className="nav-item">
                                                    <Link href="/dashboard/applications-redirect-urls" className={`nav-link ${isActiveLink('/dashboard/applications-redirect-urls') && 'nav-link-active'}`}>
                                                        Applications and Redirect URLs
                                                    </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link href="/dashboard/api-key" className={`nav-link ${isActiveLink('/dashboard/api-key') && 'nav-link-active'}`}>
                                                        API Key
                                                    </Link>
                                                </li>
                                                <li className='nav-item'>
                                                    <a href="/static/Terms of Use Developer Services Cyclomedia 250416.pdf" download="Terms of Use Developer Services Cyclomedia.pdf" className="nav-link">
                                                        Download User Agreement
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                ) : null}
                                <li className='nav-item'>
                                    <a className='nav-link' href='#' onClick={(e) => { e.preventDefault(); logout(); }}>Logout</a>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <Link href="https://info.cyclomedia.com/developerrequest" className={`nav-link ${isActiveLink('https://info.cyclomedia.com/developerrequest') && 'nav-link-active'}`} >Stay up to date</Link>
                                </li>
                                <li className='nav-item'>
                                    <a className='nav-link' href='#' onClick={(e) => { e.preventDefault(); login(); }}>Login</a>
                                </li>
                            </>
                        )
                        }
                    </ul>
                </div>
            </nav>
        </div>
    )
};

export default AuthenticatedHeaderMenu;